import { render } from "./InputSupplier.vue?vue&type=template&id=15c61d45"
import script from "./InputSupplier.vue?vue&type=script&lang=js"
export * from "./InputSupplier.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__